var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6212,
    cy: 23.1886,
    r: 22.8526,
    fill: "#E4572E",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.662 18.7061C28.662 21.5027 26.4197 23.7451 23.6211 23.7451C20.8234 23.7451 18.5802 21.5027 18.5802 18.7061C18.5802 15.9095 20.8234 13.668 23.6211 13.668C26.4197 13.668 28.662 15.9095 28.662 18.7061ZM23.6209 32.7118C19.4907 32.7118 16.0034 32.0405 16.0034 29.4505C16.0034 26.8596 19.5126 26.2121 23.6209 26.2121C27.7521 26.2121 31.2385 26.8834 31.2385 29.4734C31.2385 32.0643 27.7293 32.7118 23.6209 32.7118Z",
    fill: "#E4572E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUser);
export default __webpack_public_path__ + "static/media/activeUser.76db708151802a53363274e6e870c140.svg";
export { ForwardRef as ReactComponent };